// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SORB1","content":"styles_content__20dwr","tableWrap":"styles_tableWrap__2FQWc"};